import * as d3 from 'd3'
import html2canvas from 'html2canvas';

import { Component, OnChanges, Input, ViewChild, ElementRef } from '@angular/core';
import { Tooltip, TooltipModule } from 'primeng/tooltip';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { NgClass } from '@angular/common';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { orderBy } from 'lodash';

@Component({
  selector: 'horizontal-poll-graph',
  templateUrl: './horizontal-poll-graph.component.html',
  standalone: true,
  imports: [
    TooltipModule,
    AfTranslatePipe,
    AfTranslateDirective,
    NgClass]
})

export class HorizontalPollGraphComponent implements OnChanges {
  horizontalPollGraph:any = {
    showExpandGraph: false,
    id: this.commonUtilsService.createId(),
    textCaptureImage: 'results-report.capture-image'
  };
  constructor( private commonUtilsService: CommonUtilsService,
    private modalService: ModalServiceService,
    private container: ElementRef ) { }
  @Input() additionalInfo: any;
  @Input() graphData: any;
  @Input() isModal: boolean=false;
  @Input() fromComponent: string;
  @ViewChild(Tooltip) tooltip:Tooltip;

  ngOnChanges(): void {
    if(this.graphData){
      this.configureData();
      let that: any = this.horizontalPollGraph;
      if(that.svg){
        that.svg.remove();
      }
      this.drawGraph();
    }
  }

  configureData(){
    this.horizontalPollGraph.dataList = this.isModal?[...this.graphData.original]:orderBy(this.graphData.original, 'percentage');
    if(!this.isModal && this.horizontalPollGraph.dataList.length > 10){
      this.horizontalPollGraph.dataList = this.horizontalPollGraph.dataList.sort(this.orderListAnswers).slice(0, 10);
      this.horizontalPollGraph.showExpandGraph = true;
      this.horizontalPollGraph.textCaptureImage = 'results-report.capture-image-reduce';
    }else if(this.isModal){
      this.horizontalPollGraph.textCaptureImage = 'results-report.capture-image-complete';
    }
    for(var i = 0; i < this.horizontalPollGraph.dataList.length; i++){
      this.horizontalPollGraph.dataList[i].ind = i;
    }
  }

  orderListAnswers(a:any, b:any) {
    if(a.answers < b.answers){
      return 1;
    }
    return a.answers > b.answers ? -1 : 0;
  }

  drawGraph(){
    let that: any = this.horizontalPollGraph;
    that.graphWidth = 332;
    that.graphHeight = 332;
    that.graphBarWidth = 332;
    if(this.isModal){
      let heightBar: any = 24;
      that.graphHeight = this.fromComponent === 'graphReport'? 767: (that.dataList.length*heightBar)-2;
      that.labelWidth = this.fromComponent === 'graphReport'? 258 : 100;
      that.graphWidth = this.fromComponent === 'graphReport'? 790 - that.labelWidth : 508 ;
      that.graphLeft = this.fromComponent === 'graphReport'? 258: 112;
      that.graphRight = this.fromComponent === 'graphReport'? 90: 50;
    }
    that.margin = {
      bar: this.isModal?2:4,
      canvas: 8,
      left: this.isModal?that.graphLeft:0,
      right: this.isModal?that.graphRight:0
    };
    that.width = that.graphWidth - that.margin.right + that.margin.left,
    that.height =  that.graphHeight + that.margin.canvas;
    this.drawSvg();
    this.drawAxxis();
    this.drawCanvas();
  }

  drawSvg(){
    let that: any = this.horizontalPollGraph;
    let height: any = that.height + that.margin.canvas;
    that.svg = d3.select(this.container.nativeElement.firstChild.firstChild)
      .append("svg")
      .attr("width", that.width)
      .attr("height", height)
      // .attr("viewBox", `0 0 ${that.width} ${height}`)
      .attr("class", !this.isModal? "horizontal-poll-graph__graph-svg" : "");
    if(this.isModal){
      that.svg.append("foreignObject")
        .attr("width", that.graphWidth)
        .attr("height", height)
        .attr("transform", "translate("+ that.margin.left +",0)")
        .attr("class", "horizontal-poll-graph__graph-svg-modal");
    }
    that.canvas = that.svg.append("g")
      .attr("class", 'horizontal-poll-graph__canvas')
      .attr("transform",
          "translate(" + (that.margin.canvas+that.margin.left) + ",0)");
  }

  drawAxxis(){
    let that: any = this.horizontalPollGraph;
    that.y = d3.scaleBand()
      .range([that.height, 0])
      .padding(0);
    that.x = d3.scaleLinear()
      .range([0, that.graphBarWidth]);
    that.x.domain([0, 100])
    that.y.domain(that.dataList.map((d:any) => {
      return d.label;
    }));
  }

  drawCanvas(){
    let that: any = this.horizontalPollGraph;
    let bar:any = that.canvas.selectAll(".bar")
      .data(that.dataList)
      .enter()
      .append("g")
      .attr("class", "horizontal-poll-graph__bar-block")
      .attr("transform", (d:any, i:any)=> {
        return "translate(0," + i * that.y.bandwidth() + ")";
      });

    bar.append("rect")
      .attr("width", (d:any)=>{
        return !d.percentage? 1 : (d.percentage / 100) * that.graphBarWidth;
      })
      .attr("height", that.y.bandwidth() - that.margin.bar)
      .attr("rx", 4)
      .attr("ry", 4)
      .attr("class", "horizontal-poll-graph__percent-bar")
      .attr("fill", (d:any)=>{
        return d.color;
        // return 'var('+d.color+')';
      })
      .attr("transform", "translate(0,"+ that.margin.bar +")");

    if(this.isModal){
      bar.append("foreignObject")
        .attr("width", that.labelWidth)
        .attr("height", that.y.bandwidth())
        .attr("transform", "translate(-"+(that.labelWidth)+","+((that.y.bandwidth() / 2) - 8) +")")
        .append("xhtml:div")
        .attr("class", "horizontal-poll-graph__y-label")
        .text((d:any) =>{
          return d.label;
        });

    }else{
      bar.on("mousemove", (ev: any, d:any)=>{
        let tooltipBlock: any = document.getElementById('tooltip-poll-graph-'+this.horizontalPollGraph.id);
        d3.select('#tooltip-poll-graph-inner-'+this.horizontalPollGraph.id)
          .text(d.label);
        d3.select('#tooltip-poll-graph-'+this.horizontalPollGraph.id)
          .style("top", (d.ind)*that.y.bandwidth() + (that.margin.bar/2) + ((that.y.bandwidth() - tooltipBlock.offsetHeight) / 2) +"px")
          .style("left", "-"+ (tooltipBlock.offsetWidth + that.margin.canvas) +"px");
      })
      bar.on("mouseover", ()=>{
        d3.select('#tooltip-poll-graph-'+this.horizontalPollGraph.id).style("visibility", "visible");
      })
      bar.on("mouseout", ()=>{
        d3.select('#tooltip-poll-graph-'+this.horizontalPollGraph.id).style("visibility", "hidden");
      });
    }

    let foreignDiv:any = bar.append("foreignObject")
      .attr("width", (d:any)=>{
        var width = that.width - ((d.percentage / 100) * that.width );
        return width < 85? 85 : width;
      })
      .attr("height", ()=>{
        return that.y.bandwidth() - that.margin.bar;
      })
      .attr("transform", (d:any) => {
        var translateX = (d.percentage / 100) * that.graphBarWidth ;
        if( (that.graphBarWidth - translateX) < 85){
          return "translate("+ ((that.graphBarWidth - 85) - 14)  +","+ that.margin.bar +" )";
        }else{
          return "translate("+ (translateX+8) +","+ that.margin.bar +")";
        }
      })
      .append("xhtml:div")
      .attr("class", (d:any)=>{
        var width = that.graphBarWidth - ((d.percentage / 100) * that.graphBarWidth );
        return width < 85? "horizontal-poll-graph__legend-block horizontal-poll-graph__legend-block--full" : "horizontal-poll-graph__legend-block";
      })

    let legendBlock:any = foreignDiv.append('div')
      .attr("class","horizontal-poll-graph__legend-block-inner")
      .attr('id', (d:any)=>{ return 'horizontal-poll-graph__legend-block-inner-'+ d.ind + '-' + this.horizontalPollGraph.id});

    legendBlock.append('div')
      .attr("class","horizontal-poll-graph__percent-block")
      .text((d:any)=>{
        return d.percentage+'%'
      });

    legendBlock.append('div')
      .attr("class","horizontal-poll-graph__answers-block")
      .append('p')
      .attr("class","horizontal-poll-graph__answers-block-text")
      .text((d:any)=>{
        return d.answers;
      });
  }

  saveAsPng(){
    let that = this;
    that.horizontalPollGraph.disabledSaveAsPng = true;
    setTimeout(()=>{
      html2canvas(this.container.nativeElement.firstChild.firstChild)
        .then(function(canvas) {
          canvas.toBlob((blob:any)=>{
            let data = [new ClipboardItem({ [blob.type]: blob })];
            navigator.clipboard.write(data)
              .then(()=>{}, (err)=>{})
          });
          that.horizontalPollGraph.disabledSaveAsPng = false;
          that.horizontalPollGraph.showTooltip = true;
          setTimeout(()=>{
            that.tooltip.show();
          }, 100)
          setTimeout(()=>{
            that.tooltip.hide();
            that.horizontalPollGraph.showTooltip = false;
          }, 3000)
        })
      }, 100)
  }

  expandGraph(){
    let configuration: any = {
      additionalInfo: this.additionalInfo,
      graphData: this.graphData,
      type: 'result-report'
    }
    this.modalService.viewExtendedReport(configuration);
  }
}
